import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgMoreEpisodes } from '../../../icons';
import { EpisodeAsset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { getPreferredRecording } from '../../../queries/ats/titles/utils/recording-utils';
import { details } from '../../../routes/routes';
import { InputContext } from '../use-input-context';
import { ActionLink } from './action-button/action-button';
import styles from './details-button.module.scss';

interface MoreEpisodesButtonProps {
  asset: EpisodeAsset;
  source: Source;
  params?: Partial<InputContext>;
}

export const MoreEpisodesButton = forwardRef<HTMLAnchorElement, MoreEpisodesButtonProps>(
  ({ asset, source, params }, ref) => {
    const { t } = useTranslation();

    const isRecording = details.isRecording(asset);

    if (isRecording && source.type === 'program') {
      const recording = getPreferredRecording(source, true);

      if (recording === undefined) {
        return null;
      }

      return (
        <ActionLink
          ref={ref}
          className={styles.secondary}
          variant="bordered"
          as="details"
          options={{
            type: 'recording',
            subType: 'series',
            id: recording.series?.id ?? recording.programId,
          }}
        >
          <SvgMoreEpisodes className={styles.icon} />
          {t('details:more-episodes')}
        </ActionLink>
      );
    }

    return (
      <ActionLink
        ref={ref}
        className={styles.secondary}
        variant="bordered"
        as="details"
        params={params}
        options={{
          type: 'series',
          id: asset.series.masterId,
        }}
      >
        <SvgMoreEpisodes className={styles.icon} />
        {t('details:more-episodes')}
      </ActionLink>
    );
  },
);
